import {connect} from 'react-redux';
import {IEditorState} from '../../../redux/modules/editor/reducer';
import {IConsoleState} from '../../../redux/modules/console/reducer';
import {SessionEditorRunCode as Container, ISessionEditorRunCodeProps} from './run-code-ui';

interface IStore {
  editor: IEditorState;
  console: IConsoleState;
}

const mapStateToProps = (state: IStore) => ({
  codeRunning: state.console.running && !state.console.runTests,
  testsRunning: state.console.running && state.console.runTests,
  editorValue: state.editor.value,
  disabled: state.console.running,
});

const mapDispatchToProps = {};

export const SessionEditorRunCode = connect<ISessionEditorRunCodeProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(Container);

